{
  "version": 1,
  "asset_id": "0a45158f-1649-4967-aa26-914b1cef2bb6",
  "project_id": "8d7278d8-f7c2-487a-a967-889b9bac3b6c",
  "url": "/__l5e/assets-v1/0a45158f-1649-4967-aa26-914b1cef2bb6/cashless-payments-only.png",
  "r2_key": "a/v1/8d7278d8-f7c2-487a-a967-889b9bac3b6c/0a45158f-1649-4967-aa26-914b1cef2bb6/cashless-payments-only.png",
  "original_filename": "cashless-payments-only.png",
  "size": 7139,
  "content_type": "image/png",
  "created_at": "2026-07-03T06:45:56Z"
}
